'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import cookieToMap from '@haaretz/s-cookie-utils/cookieToMap';
import useOnce from '@haaretz/s-use-once';
import React from 'react';
const CookieContext = /*#__PURE__*/ React.createContext(undefined);
const CookieSetter = /*#__PURE__*/ React.createContext(undefined);
function cookieDispenserFactory(cookie) {
    const cookieMap = cookieToMap(cookie, true);
    const { ppResponseMessage, userDetails, user_details, acl, _htzwif, OptanonConsent, lbcounter, gcounter } = cookieMap;
    return {
        ppResponseMessage,
        userDetails,
        user_details,
        acl,
        _htzwif,
        OptanonConsent,
        lbcounter,
        gcounter,
        abTestGroup: cookieMap['ab-test-group']
    };
}
export function CookieProvider({ children }) {
    const [cookie, setCookie] = React.useState(cookieDispenserFactory(typeof window === 'undefined' ? /* istanbul ignore next */ '' : document.cookie));
    const cookieSetter = React.useCallback((action)=>{
        setCookie(cookieDispenserFactory(typeof window === 'undefined' ? /* istanbul ignore next */ action ?? '' : document.cookie));
    }, []);
    React.useEffect(()=>{
        cookieSetter();
    }, [
        cookieSetter
    ]);
    return /*#__PURE__*/ _jsx(CookieContext, {
        value: cookie,
        children: /*#__PURE__*/ _jsx(CookieSetter, {
            value: cookieSetter,
            children: children
        })
    });
}
/**
 *
 * @param startFrom - Determines the initial source of the cookie values:
 *   * `serverValue`: Use this when the cookie values affect the initial render of a component to prevent hydration mismatches.
 *   * `cookieValue`: Use this when the cookie values are only needed after an effect or inside an event handler.
 *
 * @returns The current cookie values.
 * @throws An error if used outside of a `CookieProvider`.
 */ export default function useCookie(startFrom) {
    const context = React.use(CookieContext);
    const [updatedStartFrom, setUpdatedStartFrom] = React.useState(startFrom);
    useOnce(()=>{
        setUpdatedStartFrom('cookieValue');
    }, startFrom === 'serverValue');
    if (context === undefined) {
        throw new Error('useCookie must be used within a CookieProvider');
    }
    if (updatedStartFrom === 'serverValue') {
        return {};
    }
    return context;
}
export function useSetCookie() {
    const context = React.use(CookieSetter);
    if (context === undefined) {
        throw new Error('useSetCookie must be used within a CookieProvider');
    }
    return context;
}
/**
 * @param startFrom - Determines the initial source of the cookie values:
 *   * `serverValue`: Use this when the cookie values affect the initial render of a component to prevent hydration mismatches.
 *   * `cookieValue`: Use this when the cookie values are only needed after an effect or inside an event handler.
 *
 * @returns The current cookie values.
 * @throws An error if used outside of a `CookieProvider`.

 */ export function useCookieAtom(startFrom) {
    return [
        useCookie(startFrom),
        useSetCookie()
    ];
}

//# sourceMappingURL=cookieAtom.js.map